// Contact form dataLayer tracking (CF7 events + view/start flows).
// Loaded here so it ships on every page that includes the footer modal.
import "./contact-tracking.js";

// Contact Form: open/close + submit feedback (CF7 hooks below).
document.addEventListener("DOMContentLoaded", function () {
  const contact__modal = document.querySelector(".contact__modal");
  const contact__modal__contenido = document.querySelector(".contact__modal__contenido");
  const contact__modal_close = document.querySelector(".contact__modal__close");
  const contact__modal__close_x = document.querySelector(".contact__modal__close-x");

  if (!contact__modal || !contact__modal__contenido) {
    return;
  }

  const contact__form = contact__modal.querySelector(".wpcf7-form");
  const contact__form_status = contact__modal.querySelector(".contact__form-status");

  // Restores the submit button + status text to their default state, so the
  // form is ready for a new submission every time the modal opens/closes.
  function resetContactFormFeedback() {
    if (contact__form) {
      contact__form.classList.remove("contact-form--sending");
    }
    if (contact__form_status) {
      contact__form_status.hidden = true;
    }
  }

  function openContactModal() {
    resetContactFormFeedback();
    document.body.classList.add("modal-open");
    contact__modal.classList.add("contact__modal__show");
    setTimeout(() => {
      contact__modal__contenido.classList.add("contact__modal__contenido__show");
    }, 10); // Tiempo para asegurar que el display flex se aplique antes de la animación
  }

  function closeContactModal() {
    contact__modal__contenido.classList.remove("contact__modal__contenido__show");
    document.body.classList.remove("modal-open");
    setTimeout(() => {
      contact__modal.classList.remove("contact__modal__show");
      resetContactFormFeedback();
    }, 500); // Tiempo para que termine la animación
  }

  // Canonical contact-form trigger: any `.boton__cta` (header/footer "Hablemos")
  // opens the shared contact modal. The service landing pages style their
  // primary contact CTAs with their own BEM classes (`.ae-btn--primary`,
  // `.gm-btn--primary`, `.gms-btn--primary`) instead of `.boton__cta`, so they
  // are wired here too — they open the exact same modal, no new mechanism.
  const btn_contact = document.querySelectorAll(
    ".boton__cta, .ae-btn--primary, .gm-btn--primary, .gms-btn--primary"
  );

  btn_contact.forEach((btn) => {
    btn.addEventListener("click", () => {
      openContactModal();
    });
  });

  contact__modal.addEventListener("click", (e) => {
    if (e.target == contact__modal || e.target == contact__modal_close || e.target == contact__modal__close_x) {
      closeContactModal();
    }
  });

  // Submit feedback: CF7 takes a couple of seconds to answer and gives no
  // visible cue of its own (its default spinner is neutralised elsewhere in
  // contacto.css), so clicking "Enviar" looked like nothing happened. Hide
  // the submit button + show "Enviando..." the moment the native submit
  // fires (before CF7's own ajax kicks in, `novalidate` means it always
  // fires), then react to CF7's lifecycle events for success/error.
  if (contact__form) {
    contact__form.addEventListener("submit", () => {
      contact__form.classList.add("contact-form--sending");
      if (contact__form_status) {
        contact__form_status.hidden = false;
      }
    });

    contact__form.addEventListener("wpcf7mailsent", () => {
      // The success message ("Gracias por tu mensaje...") is already shown
      // by CF7 itself (.wpcf7-response-output); give the user a moment to
      // read it, then close the modal automatically (resets the button/
      // status too, same path as a manual close).
      setTimeout(closeContactModal, 3000);
    });

    ["wpcf7invalid", "wpcf7mailfailed", "wpcf7spam"].forEach((eventName) => {
      contact__form.addEventListener(eventName, resetContactFormFeedback);
    });
  }
});

// Función para manejar el subrayado y font weight de los elementos del menú
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll("section");
  const menuLinks = document.querySelectorAll(".menu-item a");
  let menuObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        menuLinks.forEach(link => {
          link.classList.remove("active");
          if (link.getAttribute("href").substring(1) === entry.target.id) {
            link.classList.add("active");
          }
        });
      }
    });
  }, { threshold: 0.5 });
  sections.forEach(section => {
    menuObserver.observe(section);
  });
});

// Menú Toggle
document.addEventListener("DOMContentLoaded", function () {
  const menubtn = document.querySelector(".menuToggle__checkbox");
  const menu = document.querySelector(".menu-mobile");

  if (!menubtn || !menu) {
    return;
  }

  menubtn.addEventListener("click", function () {
    if (!menu.classList.contains('show')) {
      menu.classList.add("show");
    } else {
      menu.classList.remove("show");
    }
  });

  // Cerrar el menú al hacer clic en un enlace
  const menuLinks = menu.querySelectorAll("a");
  menuLinks.forEach((link) => {
    link.addEventListener("click", function () {

      menu.classList.remove("show");
    });
  });

  // Submenús expandibles dentro del menú mobile ("Qué hacemos" y similares).
  // El menú nativo de WP emite .menu-item-has-children con un .sub-menu hijo.
  // Inyectamos un botón toggle por ítem padre que expande/colapsa su submenú
  // (accesible vía aria-expanded), sin romper el toggle del menú principal.
  const parents = menu.querySelectorAll(".menu-item-has-children");
  parents.forEach((parent) => {
    const submenu = parent.querySelector(":scope > .sub-menu");
    if (!submenu) {
      return;
    }

    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "menu__submenu-toggle";
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Mostrar submenú");
    toggle.innerHTML = '<span class="menu__submenu-toggle-icon" aria-hidden="true">▾</span>';

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = submenu.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    // El botón se inserta antes del submenú para no alterar el orden del DOM.
    submenu.parentNode.insertBefore(toggle, submenu);
  });
});

// Ítem "Qué hacemos": disparador del submenú, nunca un link navegable.
// Independiente del bloque de arriba (no depende de .menu-mobile / .menuToggle)
// porque este anchor existe en las 3 instancias del menú (header mobile,
// header desktop, footer). ServiciosSubmenu.php ya neutraliza su href a "#"
// para no romper el scroll-spy (`.menu-item a` en la sección de arriba,
// que asume href no-nulo); acá evitamos el salto a top de página que "#"
// dispara por default, sin tocar el foco (el :focus-within del dropdown
// desktop sigue funcionando igual que antes).
document.addEventListener("DOMContentLoaded", function () {
  const dropdownTriggers = document.querySelectorAll(".menu-item-has-children > a");
  dropdownTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
    });
  });
});